export default __webpack_public_path__ + "programming.3f0554ba.png";